import Page from "../../../layout/Page/Page";
import PageWrapper from "../../../layout/PageWrapper/PageWrapper";
import { CommonWorkOrderList } from "./Common/CommonWorkOrderList";

const WorkOrderPage = () => {
	return (
		<PageWrapper title='Ordens de Serviço'>
			<Page container='fluid'>
				<div className='row'>
					<div className='col-12'>
						<CommonWorkOrderList />
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default WorkOrderPage;